"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _ConfirmBlockTradeModalComponent = _interopRequireDefault(require("./ConfirmBlockTradeModalComponent"));
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
var _orderEntryActions = require("../../redux/actions/orderEntryActions");
var _orderEntrySelector = require("../../redux/selectors/orderEntrySelector");
var _snackbarActions = require("../../redux/actions/snackbarActions");
var _orderFormTypes = require("../../constants/sendOrder/orderFormTypes");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var form = state.form,
    product = state.apexCore.product;
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var productId = form.reportBlockTrade.values.fee.ProductId || form.reportBlockTrade.values.fee.FeeProductId;
  var feeSymbol = productId ? product.products.find(function (item) {
    return item.ProductId === productId;
  }).Product : '';
  var orderTotal = (0, _orderEntrySelector.orderTotalSelector)(state, {
    formName: 'reportBlockTrade'
  });
  return {
    formObj: form.reportBlockTrade || {
      values: {}
    },
    selectedInstrument: selectedInstrument,
    feeSymbol: feeSymbol,
    orderTotal: orderTotal
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
  var useNewForm = _ref.useNewForm;
  return {
    confirmReport: function confirmReport(form) {
      return dispatch((0, _orderEntryActions.placeOrder)(_orderFormTypes.orderFormTypes.block, form, {
        useNewForm: useNewForm
      })).then(function (result) {
        if (result.status === 'Accepted') {
          dispatch((0, _orderEntryActions.clearOrderForm)('reportBlockTrade'));
        }
        if (result.result === false) {
          dispatch((0, _snackbarActions.showSnack)({
            id: 'confirmBlockTradeFail',
            text: result.detail,
            type: 'warning'
          }));
        }
      });
    }
  };
};
var container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ConfirmBlockTradeModalComponent["default"]);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.CONFIRM_BLOCK_REPORT
})(container);